import * as React from 'react';
import { SVGProps } from 'react';

const SvgPause = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 18h3.75V6H7v12zm6.25-12v12H17V6h-3.75z" />
  </svg>
);

export default SvgPause;
